export default function Modal({ show, onClose, title, children, classname, buttons = [], showBtn = true }) {
  return (
    <div className={`modal fade ${show ? "show d-block" : ""}  ${classname}`} tabIndex="-1" role="dialog" style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {children}
          </div>
          <div className="modal-footer">

            {buttons && buttons.length > 0 ? (
              buttons.map((btn, i) => (
                <button
                  key={i}
                  type={btn.type || "button"}
                  className={btn.className || "btn btn-secondary"}
                  onClick={btn.onClick || onClose}
                >
                  {btn.label || "Button"}
                </button>
              ))
            ) : (
              showBtn === true && (
                <button type="button" className="btn btn-primary" onClick={onClose}>
                  Close
                </button>
              )
            )}

          </div>
        </div>
      </div>
    </div>
  );
}
